import { Component, OnInit, OnDestroy, Renderer } from '@angular/core';
import { InformacionService } from '../../services/informacion.service';

@Component({
  selector: 'app-servicios',
  templateUrl: './servicios.component.html',
  styles: []
})
export class ServiciosComponent implements OnInit, OnDestroy {
  servicios: any[];
  constructor(public _is: InformacionService, private renderer: Renderer) {
    this.renderer.setElementClass(document.body, 'paginas-internas', true);
    console.log (this._is.servicios)
   }

  ngOnInit() {
    
  }

  ngOnDestroy() {
    this.renderer.setElementClass(document.body, 'paginas-internas', false);
  }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/components/servicios/servicios.component.ts